export function rateFormatter(rate: number): string {
  return (rate * 100).toFixed(2)
}
